/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getTargetList = (params) =>
  makeApiCall(`/doctors-target/request/list`, 'POST', params);

export const postUpdateStatus = (params) =>
  makeApiCall(`/doctors-target/request/update`, 'POST', params);
